import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { Auth } from 'aws-amplify';
import { environment } from '../../../../environments/environment';
import { CONSTANTS } from '../../../app.constants';
import { fetchAuthSession, signOut } from 'aws-amplify/auth';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public token!: string;
  public defaultRequestParams: IDefaultRequestParams;

  constructor(private http: HttpClient) {
    this.defaultRequestParams = {
      app_id: CONSTANTS.APP_ID,
      //app_version: environment.APP_VERSION,
      device_id: CONSTANTS.DEVICE_ID,
      device_type: CONSTANTS.DEVICE_TYPE,
      sys_user_id: '',
      sys_user_type: '',
    };
  }

  getToken(): string {
    return this.token;
  }

  getDefaultParams(): IDefaultRequestParams {
    return this.defaultRequestParams;
  }

  getDefaultHeaders() {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + this.token,
    };
    return headers;
  }

  
  async logout() {
    window.localStorage.removeItem("mp-serve-auth");
    window.localStorage.removeItem("mpuserdetailslock");
    window.localStorage.removeItem("mpUInfo");
    window.localStorage.removeItem('cookieDetails');
    window.localStorage.removeItem('cookieStartTimer');
    window.localStorage.removeItem('cookieEndTimer');

    const redirectSignOut = (environment.config as any).Auth?.Cognito?.loginWith?.oauth?.redirectSignOut?.[0]
      || (environment.config as any).oauth?.redirectSignOut
      || '/';

    try {
      await signOut({ global: true });
    } catch (error) {
      console.error('Amplify signOut failed:', error);
    } finally {
      window.open(redirectSignOut, "_self");
    }
  }

}


export interface IDefaultRequestParams {
  app_id: string;
  //app_version: string;
  device_id: string;
  device_type: string;
  sys_user_id: string;
  sys_user_type: string;
}
